export const address_types = {
  delivery: 'Delivery',
  billing: 'Billing',
}

export const address_tags = ['Home', 'Office', 'Other']
